<template>
  <a-modal
    ref="createModal"
    title="新增"
    :width="1200"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <div class="table-page-operator-wrapper">
      <a-button :loading="newLoading" @click="addLine()" type="primary">新增行</a-button>
    </div>
    <a-table
      ref="modalTable"
      :columns="columns"
      :scroll="{x: 1000,y: 300}"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
    >
      <!-- 来源分类 -->
      <template slot="itemCode" slot-scope=" text, record ">
        <global-select
          @change="(val)=>itemCodeHandler(val, record)"
          :value.sync="record.itemCode"
          selectType="selectSearch"
          searchParam="itemCode"
          :dropdown-match-select-width="false"
          requestApi="/scp/scpMpsPlans/listItemCode"
          :selectItem="{ value: 'realValue', label: 'label' }"
        />
      </template>
      <template slot="supplierName" slot-scope=" text, record ">
        <!--        <global-select
          @change="(val,list)=>itemSupplierNameHandler(val,list, record)"
          :value.sync="record.supplierName"
          selectType="select"
          :dropdown-match-select-width="false"
          requestApi="/scp/scpMpsPlans/listSupplierCode"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :setParams="{ itemId: currentSelectedItemId }"
        />-->
        <lsSelectPage
          :datas="listSupplierMap[record.itemId] || []"
          placeholder="请选择"
          :value.sync="record.supplierName"
          @change="(val,list)=>itemSupplierNameHandler(val,list, record)"
        >
          <template slot="select-option" slot-scope="{items}">
            <a-select-option v-for="i in items" :key="i.selectedValue" :value="i.realValue" :title="i.label">
              {{ i.label }}
            </a-select-option>
          </template>
        </lsSelectPage>
      </template>
      <template slot="quantity" slot-scope=" text, record ">
        <a-input-number v-model="record.quantity" :min="0" />
      </template>

      <template slot="newDuckDate" slot-scope=" text, record ">
        <a-date-picker
          v-model="record.newDuckDate"
          valueFormat="YYYY-MM-DD"
        />
      </template>

      <template slot="baseUnitOfMeasure" slot-scope="text, record">
        {{ record.baseUnitOfMeasure }}
      </template>
      <span slot="operation" slot-scope="text, record">
        <a @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
// import { addUnit } from '@/api/mdm/units/standardUnit'
import {
  apiLeadByItemCode,
  apiLeadBySupplierCode,
  apiGetOrderNumber,
  apiAddSupplierDetail,
  apiListSupplierCode
} from '@/api/mps/basic-data/mps-supply-details.js'

// 表单字段
export default {
  props: {
    uomClassOptions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      version: '',
      // 状态数据字典
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 当前控件配置:
      newLoading: false,
      confirmLoading: false,
      visible: false,
            // 表格字段
      typeList: [],
      listSupplierMap: {},
      unitOfMeasureList: [],
      columns: [
              {
                title: '物料编码',
                dataIndex: 'itemCode',
                scopedSlots: { customRender: 'itemCode' },
                ellipsis: true,
                width: 150,
                align: 'center'
              },
              {
                title: '工艺大类',
                dataIndex: 'category',
                ellipsis: true,
                align: 'center',
                width: 180
              },
              {
                title: '物料名称',
                width: 120,
                dataIndex: 'itemName',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '规格描述',
                width: 120,
                ellipsis: true,
                dataIndex: 'specification',
                align: 'center'
              },
              {
                title: '供应商',
                width: 180,
                dataIndex: 'supplierName',
                scopedSlots: { customRender: 'supplierName' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '内外部',
                width: 180,
                dataIndex: 'supplierClass',
                scopedSlots: { customRender: 'supplierClass' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '订单类型',
                width: 180,
                dataIndex: 'orderType',
                scopedSlots: { customRender: 'orderType' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '单据编号',
                width: 180,
                dataIndex: 'orderNumber',
                // scopedSlots: { customRender: 'orderNumber' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '完成日期',
                width: 180,
                dataIndex: 'newDuckDate',
                scopedSlots: { customRender: 'newDuckDate' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '数量',
                width: 180,
                dataIndex: 'quantity',
                scopedSlots: { customRender: 'quantity' },
                ellipsis: true,
                align: 'center'
              },
              {
                title: '锁定成本',
                width: 180,
                dataIndex: 'averagePurchasePrice',
                ellipsis: true,
                align: 'center'
              },
              {
                title: '操作',
                width: 150,
                fixed: 'right',
                align: 'center',
                dataIndex: 'operation',
                scopedSlots: { customRender: 'operation' }
              }
            ],
      currentSelectedItemId: ''
    }
  },
  created () {},
  methods: {
    getSupplierList (itemId) {
      if (itemId) {
        apiListSupplierCode({ itemId: itemId }).then(res => {
          if (!this.listSupplierMap[itemId]) {
            this.$set(this.listSupplierMap, itemId, res);
          }
        })
      }
    },
    itemSupplierNameHandler (val, list, record) {
      apiLeadBySupplierCode({ supplierCode: val }).then(response => {
        if (response.code === 200) {
          console.log(response.data);
          record.sourceSupplierId = response.data.sourceSupplierId
          record.sourceSupplierCode = response.data.sourceSupplierCode
          record.supplierName = response.data.supplierName // 工艺大类
          record.supplierClass = response.data.supplierClass // 物料名称
          record.supplierClassId = response.data.supplierClassId // 规格描述
        }
      }).catch(e => {
      })
    },
    // 列表-折换字段

    itemCodeHandler (val, record) {
      record.sourceSupplierId = ''
      record.sourceSupplierCode = ''
      record.supplierName = ''
      record.supplierClass = ''
      record.supplierClassId = ''
      apiLeadByItemCode({ itemCode: val }).then(response => {
        if (response.code === 200) {
//           itemId: 1166745270361399296
// itemCode: BJ-ZZ-AL000025
// itemName: PC122-A_003_床尾-黑色
// category: 皮沙发
// lockCosts: 20
// specification: 皮套扪死不能拆
          record.itemId = response.data.itemId
          this.currentSelectedItemId = record.itemId
          record.itemCode = response.data.itemCode
          record.category = response.data.category // 工艺大类
          record.itemName = response.data.itemName // 物料名称
          record.specification = response.data.specification // 规格描述
          record.averagePurchasePrice = response.data.averagePurchasePrice // 锁定成本
          this.getSupplierList(record.itemId);
        } else {
          this.$message.error(response.msg)
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 删除
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show (version) {
      this.addLine()
      this.visible = true
      this.version = version
      this.getSupplierList()
    },
    // 新增行
    addLine () {
      this.newLoading = true
      apiGetOrderNumber().then(response => {
        this.newLoading = false
        if (response.code === 200) {
          const arr = JSON.parse(JSON.stringify(this.typeList))
          const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
          const obj = {
            itemId: "",
            itemCode: "",
            category: "",
            itemName: "",
            specification: "",
            supplierName: "",
            supplierClass: "",
            averagePurchasePrice: "",
            orderType: "计划单",
            orderNumber: response.data,
            indexId: Number(indexId) + 1
          }
          arr.push(obj)
          this.typeList = arr
        }
      }).catch(e => {
        this.newLoading = false
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    // 保存
    confirm () {
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        console.log(this.typeList[i])
        if (!this.typeList[i].itemCode || !this.typeList[i].supplierName || !this.typeList[i].newDuckDate || ((!this.typeList[i].quantity) && this.typeList[i].quantity !== 0)) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      apiAddSupplierDetail({ version: this.version, listDetail: this.typeList }).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 150px;
}
</style>
